module.exports = {"en":{"manage_profiles":"Manage profiles"},"de":{"manage_profiles":"Profile verwalten"},"fr":{"manage_profiles":"Gérer les profils"},"ru":{"manage_profiles":"Управление профилями"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfileSelector/profile-selector.json
// module id = 964
// module chunks = 0